// People who can see the board (spec §13.3): names for card avatars and the
// assignee picker. Loaded by the board page; refreshed when a card is opened.
import type { Person } from '../../shared/api.ts';
import type { CardPeople } from './face.ts';

export class People implements CardPeople {
  /** Called after the list changes (faces showing avatars need redrawing). */
  onChange: () => void = () => {};
  /** Fetches the list again, if the board page provided a way to. */
  refresh: (() => void) | null = null;
  version = 0;
  private names = new Map<string, string>();
  private people: Person[] = [];

  get list(): readonly Person[] { return this.people; }

  name(userId: string): string | null {
    return this.names.get(userId) ?? null;
  }

  set(list: readonly Person[]): void {
    const next = [...list].sort((a, b) => a.name.localeCompare(b.name) || (a.id < b.id ? -1 : 1));
    if (JSON.stringify(next) === JSON.stringify(this.people)) return;
    this.people = next;
    this.names = new Map(next.map((p) => [p.id, p.name]));
    this.version++;
    this.onChange();
  }
}
